export default __webpack_public_path__ + "static/media/marauders-map-v3-04-02.c2818fd7.jpg";